// src/App.js

import React from 'react'; // 'Suspense' and 'lazy' are removed
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Import non-page components directly
import Navbar from './components/NavBar';
import Footer from './components/Footer';
import AnnouncementBar from './components/AnnouncementBar';
import SmoothScroll from './components/SmoothScroll';
import './styles/Global.css';
import './App.css';
// AppLoader is no longer needed here as a fallback
// import AppLoader from './components/AppLoader';

// --- UPDATED: All page components are now imported directly ---
import HomePage from './pages/HomePage';
import SNTAM from './pages/SNTAM';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import SpeakerPage from './pages/SpeakerPage';
import AllBlogsPage from './components/blog/AllBlogPage';
import BookDetailPage from './pages/BookDetailPage';
import AnalyticsTracker from './components/AnalyticsTracker';

function App() {
  return (
    // Wrap the entire app in HelmetProvider for SEO management
    <HelmetProvider>
      <BrowserRouter>
      <AnalyticsTracker/>
        <SmoothScroll>
          <AnnouncementBar />
          <Navbar />
          {/* --- The Suspense wrapper has been removed --- */}
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/standing-next-to-a-mountain/*" element={<SNTAM />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/speaker" element={<SpeakerPage />} />
            <Route path="/all-blogs" element={<AllBlogsPage />} />
            <Route path="/books/:bookId" element={<BookDetailPage />} />
          </Routes>
          <Footer />
        </SmoothScroll>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;